import type { IExpenseResult } from '../../../../models/expense/ExpenseModel';
import {
  formatDecimalAmountForApi,
  formatDecimalAmountInput,
  parseDecimalAmountInput,
} from '../../../../utils/numberUtils';

export type ExpenseFormValues = {
  amount: string;
  expenseDate: string;
  description: string;
  status?: 'Pending' | 'Approved' | 'Rejected';
  files: File[];
};

export const getDefaultExpenseFormValues = (): ExpenseFormValues => {
  return {
    amount: '',
    expenseDate: new Date().toISOString().split('T')[0],
    description: '',
    files: [],
  };
};

export const getEditExpenseFormValues = (expense: IExpenseResult): ExpenseFormValues => {
  return {
    amount: formatDecimalAmountInput(expense.amount),
    expenseDate: new Date(expense.expenseDate).toISOString().split('T')[0],
    description: expense.description,
    status: expense.status,
    files: [],
  };
};

type BuildExpenseFormDataOptions = {
  deletedFileIds?: number[];
  includeStatus?: boolean;
};

export const buildExpenseFormData = (
  values: ExpenseFormValues,
  options: BuildExpenseFormDataOptions = {}
): FormData | null => {
  const parsedAmount = parseDecimalAmountInput(values.amount);
  if (parsedAmount === null) {
    return null;
  }

  const formData = new FormData();
  formData.append('amount', formatDecimalAmountForApi(parsedAmount));
  formData.append('expenseDate', new Date(values.expenseDate).toISOString());
  formData.append('description', values.description);

  if (options.includeStatus && values.status) {
    formData.append('status', values.status);
  }

  if (options.deletedFileIds?.length) {
    options.deletedFileIds.forEach(fileId => {
      formData.append('deletedFileIds', fileId.toString());
    });
  }

  if (values.files?.length) {
    values.files.forEach(file => {
      formData.append('files', file);
    });
  }

  return formData;
};
